<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column label="用户类型">
          <template slot-scope="scope">
            <span v-for="item in options.user_type"
                  v-if="item.value === scope.row.user_type">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prize_name"
                         label="奖品名称"></el-table-column>
        <el-table-column prop="stock"
                         label="库存数">
          <template slot-scope="scope">
            <span v-if="scope.row.stock === -1">无限</span>
            <span v-if="scope.row.stock !== -1">{{scope.row.stock}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reward_number"
                         label="中奖数"></el-table-column>
        <el-table-column label="总数">
          <template slot-scope="scope">
            <span v-if="scope.row.stock === -1">无限</span>
            <span v-if="scope.row.stock !== -1">{{scope.row.stock + scope.row.reward_number}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        fairid: this.$route.params.fairid,
      },
      // 搜索字段申明
      searchFieldType: {
        fairid: Number,
      },
      options: {
        user_type: [
          {label: '新用户', value: 10},
          {label: '老用户', value: 20},
        ],
      },

    }
  },
  methods: {
    getTableData (params) {
      return request.page('getFairStockTable', params)
    },
    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData ({data}) {
      this.$set(this, 'table', data)
      this.pagination.total = data.length
      this.pagination.per_page = data.length
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/fair-stock/pages/FairStockTable.vue